import { atom } from 'recoil';

export const teamId = atom({
  key: 'teamId', // unique ID (with respect to other atoms/selectors)
  default: '',
  // default value (aka initial value)
});
